import { UserInterface } from "interface";
import { createRef } from "react";

// To build the file
export const base_path = "/site/";

export const userRefrence = createRef<UserInterface>();
